module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "bb8-block"
  }, [_h('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.block.fields.id == ''),
      expression: "block.fields.id == ''"
    }],
    staticClass: "bb8-form-control bb8-block-video-url",
    attrs: {
      "placeholder": "Paste a YouTube or Vimeo video link and press enter",
      "required": ""
    },
    domProps: {
      "value": _vm.block.fields.url
    },
    on: {
      "keydown": [function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        $event.preventDefault();
        _vm.loadVideo($event)
      }, function($event) {
        if (_vm._k($event.keyCode, "delete", [8, 46])) { return; }
        _vm.removeBlock($event, true)
      }]
    }
  }), " ", (_vm.block.fields.id != '') ? _h('div', {
    staticClass: "bb8-block-video-preview"
  }, [_h('div', {
    staticClass: "bb8-block-video-wrapper"
  }, [(_vm.block.fields.plattform == 'youtube') ? _h('iframe', {
    staticClass: "bb8-block-video-iframe",
    attrs: {
      "src": '//www.youtube-nocookie.com/embed/' + _vm.block.fields.id + '?rel=0&controls=0&showinfo=0&modestbranding=1',
      "frameborder": "0",
      "allowfullscreen": ""
    }
  }) : (_vm.block.fields.plattform == 'vimeo') ? _h('iframe', {
    staticClass: "bb8-block-video-iframe",
    attrs: {
      "src": 'https://player.vimeo.com/video/' + _vm.block.fields.id + '?title=0&byline=0',
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  }) : _vm._e(), " "]), " ", _h('a', {
    staticClass: "bb8-block-remove",
    on: {
      "click": function($event) {
        _vm.removeBlock()
      }
    }
  }, [_h('svg', {
    staticClass: "icon icon-remove"
  }, [_h('use', {
    attrs: {
      "xlink:href": "#icon-remove"
    }
  })])])]) : _vm._e(), " ", _vm._t("default")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-529008d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/VideoBlock.vue
// module id = 46
// module chunks = 0